import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * DTO para la fila de Agenciamiento V2 con todos los 56 campos del Excel
 * Cada fila representa un contenedor o agrupación nave/pol/etd
 */
export class AgenciaExcelV2AgenciamientoRowDto {
  // ==================== IDENTIFICADORES ====================
  @ApiProperty({ description: 'Número de liquidación', example: '000000519' })
  nroLiquidacion!: string;

  @ApiPropertyOptional({
    description: 'Número de factura venta',
    example: 'F-12345',
  })
  nroFacturaVenta?: string;

  @ApiPropertyOptional({
    description: 'Número de nota de cobro',
    example: 'NC-12345',
  })
  nroNotaCobro?: string;

  @ApiPropertyOptional({
    description: 'Número de instrucción de embarque',
    example: 6155,
  })
  nroIE?: number;

  @ApiPropertyOptional({
    description: 'Número de B/L (Bill of Lading)',
    example: 'MEDUW9400831',
  })
  numeroBl?: string;

  @ApiPropertyOptional({
    description: 'Número de reserva/booking',
    example: 'SCLF24707600',
  })
  reserva?: string;

  @ApiPropertyOptional({
    description: 'Número de contenedor',
    example: 'FSCU5863615',
  })
  contenedor?: string;

  // ==================== CLIENTE ====================
  @ApiProperty({ description: 'Nombre del cliente', example: 'PANGALILLO SPA' })
  cliente!: string;

  @ApiPropertyOptional({
    description: 'Referencia del cliente',
    example: '256',
  })
  refCliente?: string;

  // ==================== ADUANAS ====================
  @ApiPropertyOptional({ description: 'Número de despacho', example: '18400' })
  nroDespacho?: string;

  @ApiPropertyOptional({ description: 'Número de DUS', example: '12962430-2' })
  dus?: string;

  @ApiPropertyOptional({ description: 'Estado del DUS', example: 'Legalizado' })
  estadoDus?: string;

  @ApiPropertyOptional({
    description: 'Fecha de aceptación DUS',
    example: '2025-09-01',
  })
  aceptacionDus?: string;

  @ApiPropertyOptional({ description: 'Prórroga DUS', example: 'No' })
  prorrogaDus?: string;

  // ==================== EMBARQUE ====================
  @ApiProperty({ description: 'Nombre de la nave', example: 'MARTINIQUE' })
  nave!: string;

  @ApiPropertyOptional({ description: 'Número de viaje', example: '0LIIEN1MA' })
  nroViaje?: string;

  @ApiPropertyOptional({ description: 'Naviera', example: 'ONE' })
  naviera?: string;

  @ApiProperty({ description: 'Puerto de carga', example: 'SAN ANTONIO' })
  pol!: string;

  @ApiPropertyOptional({
    description: 'Puerto de descarga',
    example: 'PHILADELPHIA',
  })
  pod?: string;

  @ApiPropertyOptional({
    description: 'País destino final',
    example: 'UNITED STATES',
  })
  paisDestinoFinal?: string;

  @ApiProperty({ description: 'Fecha ETD', example: '2025-09-07' })
  etd!: string;

  @ApiPropertyOptional({ description: 'Mes de ETD', example: 'Septiembre' })
  mes?: string;

  @ApiPropertyOptional({
    description: 'Consignatario',
    example: 'LANGE FRESH FARMS',
  })
  consignatario?: string;

  // ==================== TIPO EMBARQUE ====================
  @ApiPropertyOptional({
    description: 'Tipo de embarque',
    example: 'Contenedor',
  })
  tipoEmbarque?: string;

  @ApiPropertyOptional({ description: 'Ship Convenience', example: 'No' })
  sConv?: string;

  @ApiProperty({ description: 'Cantidad de contenedores', example: 1 })
  cntrs!: number;

  @ApiPropertyOptional({
    description: 'Tipo de bulto contenedor',
    example: 'Pallet',
  })
  tipoBultoCntr?: string;

  @ApiProperty({ description: 'Cantidad de pallets', example: 20 })
  plts!: number;

  @ApiPropertyOptional({ description: 'Cantidad de cajas', example: 1440 })
  cajas?: number;

  // ==================== PRODUCTO ====================
  @ApiPropertyOptional({ description: 'Especie', example: 'Uva' })
  especie?: string;

  @ApiPropertyOptional({ description: 'Condición', example: 'Fresco' })
  condicion?: string;

  @ApiPropertyOptional({ description: 'Tipo de embalaje', example: 'Cartón' })
  tipoEmbalaje?: string;

  @ApiPropertyOptional({ description: 'Kilos netos', example: 24768 })
  kilosNetos?: number;

  @ApiPropertyOptional({ description: 'Kilos brutos', example: 25920 })
  kilosBrutos?: number;

  @ApiPropertyOptional({
    description: 'Vía de transporte',
    example: 'Marítimo',
  })
  viaTransporte?: string;

  // ==================== MONTOS VENTA ====================
  @ApiProperty({ description: 'Monto agenciamiento', example: 98000 })
  agenciamiento!: number;

  @ApiPropertyOptional({ description: 'UCCO', example: 0 })
  ucco?: number;

  @ApiPropertyOptional({ description: 'Nro. Documento UCCO', example: '' })
  facturaUcco?: string;

  @ApiPropertyOptional({ description: 'UCCO China-Eur', example: 0 })
  uccoChinaEur?: number;

  @ApiPropertyOptional({
    description: 'Nro. Documento UCCO China-Eur',
    example: '',
  })
  facturaUccoChinaEur?: string;

  @ApiPropertyOptional({ description: 'UCCO FGN', example: 0 })
  uccoFgn?: number;

  @ApiPropertyOptional({ description: 'Nro. Documento UCCO FGN', example: '' })
  facturaUccoFgn?: string;

  @ApiPropertyOptional({ description: 'Extra UCCO', example: 0 })
  extraUcco?: number;

  @ApiPropertyOptional({ description: 'Factura Extra UCCO', example: '' })
  facturaExtraUcco?: string;

  @ApiPropertyOptional({ description: 'Extra Fito', example: 0 })
  extraFito?: number;

  @ApiPropertyOptional({ description: 'Factura Extra Fito', example: '' })
  facturaExtraFito?: string;

  @ApiPropertyOptional({ description: 'Fito', example: 0 })
  fito?: number;

  @ApiPropertyOptional({ description: 'Factura Fito', example: '' })
  facturaFito?: string;

  @ApiPropertyOptional({ description: 'Control Sello', example: 0 })
  controlSello?: number;

  @ApiPropertyOptional({ description: 'Corrección de BL', example: 0 })
  correccionBl?: number;

  @ApiPropertyOptional({ description: 'Factura Corrección BL', example: '' })
  facturaCorreccionBl?: string;

  @ApiPropertyOptional({ description: 'Gate Out', example: 15000 })
  gateOut?: number;

  @ApiPropertyOptional({ description: 'Gate In', example: 8000 })
  gateIn?: number;

  @ApiPropertyOptional({ description: 'Habilitación SAG', example: 5000 })
  habilitacionSag?: number;

  @ApiPropertyOptional({ description: 'DUS no legalizado', example: 3000 })
  dusNoLegalizado?: number;

  // ==================== MONTOS TRASPASO ====================
  @ApiProperty({ description: 'DUS Legalizado', example: 12000 })
  dusLegalizado!: number;

  @ApiPropertyOptional({ description: 'Factura DUS', example: '' })
  facturaDus?: string;

  @ApiPropertyOptional({ description: 'Exceso de recursos pallet', example: 0 })
  excesoRecursosPallet?: number;

  @ApiPropertyOptional({
    description: 'Factura Exceso de Recursos Pallet',
    example: '',
  })
  facturaExcesoRecursosPallet?: string;

  @ApiPropertyOptional({ description: 'Liberación vía email', example: 0 })
  liberacionViaEmail?: number;

  @ApiPropertyOptional({
    description: 'Factura Liberación Vía Email',
    example: '',
  })
  facturaLiberacionViaEmail?: string;

  @ApiPropertyOptional({ description: 'Matriz fuera de plazo', example: 0 })
  matrizFueraPlazo?: number;
  /** ERR-Nuevo-4: servicio de Agenciamiento que faltaba itemizar */
  diferenciaTarifaFlete?: number;

  @ApiPropertyOptional({
    description: 'Factura Matriz Fuera de Plazo',
    example: '',
  })
  facturaMatrizFueraPlazo?: string;
  facturaDiferenciaTarifaFlete?: string;

  @ApiPropertyOptional({ description: 'Multa aduana pallets', example: 0 })
  multaAduanaPlts?: number;

  @ApiPropertyOptional({
    description: 'Factura Multa Aduana PLTS',
    example: '',
  })
  facturaMultaAduanaPlts?: string;

  // ==================== SERVICIOS TARDÍOS (Traspaso) ====================
  @ApiPropertyOptional({ description: 'Late Arrival', example: 0 })
  lateArrival?: number;

  @ApiPropertyOptional({ description: 'Factura Late Arrival', example: '' })
  facturaLateArrival?: string;

  @ApiPropertyOptional({ description: 'Extra Late Arrival', example: 0 })
  extraLateArrival?: number;

  @ApiPropertyOptional({
    description: 'Factura Extra Late Arrival',
    example: '',
  })
  facturaExtraLateArrival?: string;

  @ApiPropertyOptional({ description: 'Ingreso en Puerto Tardío', example: 0 })
  ingresoPuertoTardio?: number;

  @ApiPropertyOptional({
    description: 'Factura Ingreso en Puerto Tardío',
    example: '',
  })
  facturaIngresoPuertoTardio?: string;

  @ApiPropertyOptional({ description: 'Pago Tardío de BL Export', example: 0 })
  pagoTardioBlExport?: number;

  @ApiPropertyOptional({
    description: 'Factura Pago Tardío de BL Export',
    example: '',
  })
  facturaPagoTardioBlExport?: string;

  @ApiProperty({ description: 'Security Fee Contenedor', example: 17196.75 })
  securityFeeContenedor!: number;

  @ApiPropertyOptional({ description: 'Factura Security Fee', example: '' })
  facturaSecurityFee?: string;

  @ApiPropertyOptional({ description: 'Gestión OPB', example: 10000 })
  gestionOpb?: number;

  // ==================== SERVICIOS DINÁMICOS ====================
  /**
   * Montos y documentos de servicio de esta fila, con UNA entrada por servicio
   * realmente presente en la liquidación y la clave ya resuelta para la hoja.
   *
   * Es lo que reemplaza a los campos fijos de arriba en la hoja Agenciamiento. Los
   * campos fijos siguen existiendo porque el Consolidado los consume, pero la hoja
   * Agenciamiento se arma con este mapa: así aparece CUALQUIER servicio, actual o
   * futuro, sin que nadie tenga que declararlo en la query, el builder, el DTO y el
   * transform del frontend — que es lo que pidió el cliente y lo que provocaba que
   * $34.878.789 entraran al total sin columna en el detalle (censo 2026-07-28).
   *
   * El orden de las claves ES el orden de las columnas: los servicios que ya tenían
   * columna conservan su posición y su rótulo, y los nuevos van al final.
   */
  @ApiPropertyOptional({
    description:
      'Montos y documentos de servicio, con clave dinámica por servicio presente',
    example: { scannerAduana: 7301173, facturaScannerAduana: '12345' },
  })
  servicios?: Record<string, number | string>;

  // ==================== TOTALES ====================
  @ApiProperty({ description: 'Total Venta', example: 98000 })
  totalVenta!: number;

  @ApiProperty({ description: 'Total Traspaso', example: 29196.75 })
  totalTraspaso!: number;
}

/**
 * DTO para la sección de Agenciamiento V2
 */
export class AgenciaExcelV2AgenciamientoSeccionDto {
  @ApiProperty({ type: [AgenciaExcelV2AgenciamientoRowDto] })
  rows!: AgenciaExcelV2AgenciamientoRowDto[];

  @ApiProperty({ description: 'Total contenedores', example: 4 })
  totalCntr!: number;

  @ApiProperty({ description: 'Total pallets', example: 80 })
  totalPlts!: number;

  @ApiProperty({ description: 'Total agenciamiento', example: 392000 })
  totalAgenciamiento!: number;

  @ApiPropertyOptional({ description: 'Total Gate Out', example: 15000 })
  totalGateOut?: number;

  @ApiPropertyOptional({ description: 'Total Gate In', example: 8000 })
  totalGateIn?: number;

  @ApiPropertyOptional({ description: 'Total Habilitación SAG', example: 5000 })
  totalHabilitacionSag?: number;

  @ApiPropertyOptional({
    description: 'Total DUS no legalizado',
    example: 3000,
  })
  totalDusNoLegalizado?: number;

  @ApiProperty({ description: 'Total DUS Legalizado', example: 48000 })
  totalDusLegalizado!: number;

  @ApiProperty({ description: 'Total Security Fee', example: 68787 })
  totalSecurityFee!: number;

  @ApiProperty({ description: 'Total Venta', example: 392000 })
  totalVenta!: number;

  @ApiProperty({ description: 'Total Traspaso', example: 116787 })
  totalTraspaso!: number;

  @ApiPropertyOptional({
    description: 'Servicios presentes (nombres)',
    example: ['agenciamiento', 'gateOut', 'ucco'],
  })
  serviciosPresentes?: string[];
}

/**
 * DTO para la fila de Transporte V2 - Versión completa con todos los campos
 */
export class AgenciaExcelV2TransporteRowDto {
  // ==================== IDENTIFICADORES ====================
  @ApiProperty({ description: 'Número de liquidación', example: '000000519' })
  liquidacion!: string;

  @ApiPropertyOptional({
    description: 'Número de factura venta',
    example: 'F-12345',
  })
  nroFacturaVenta?: string;

  @ApiPropertyOptional({
    description: 'Número de nota de cobro',
    example: 'NC-12345',
  })
  nroNotaCobro?: string;

  @ApiPropertyOptional({ description: 'Orden de Transporte', example: 2158 })
  ot?: number;

  @ApiPropertyOptional({ description: 'Estado', example: 'Liquidado' })
  estado?: string;

  // ==================== CLIENTE Y EXPORTADOR ====================
  @ApiProperty({ description: 'Nombre del cliente', example: 'PANGALILLO SPA' })
  cliente!: string;

  @ApiPropertyOptional({
    description: 'Nombre del exportador',
    example: 'PANGALILLO SPA',
  })
  exportador?: string;

  // ERR-05 (OPB 2026-09-30 11:34): Ref. Cliente de la OT, desde
  // `vwTransportOrders.CustomerReference`. La usa el Consolidado para las
  // filas huérfanas de transporte (sin dato de agenciamiento).
  @ApiPropertyOptional({
    description: 'Referencia del cliente en la Orden de Transporte',
    example: 'RE: E-02689-02',
  })
  refCliente?: string;

  // ==================== EMBARQUE ====================
  @ApiPropertyOptional({
    description: 'Número de booking',
    example: 'SCLF24707600',
  })
  booking?: string;

  @ApiPropertyOptional({ description: 'Naviera', example: 'ONE' })
  naviera?: string;

  @ApiPropertyOptional({
    description: 'Nombre de la nave',
    example: 'MARTINIQUE',
  })
  nave?: string;

  @ApiPropertyOptional({ description: 'Fecha ETD', example: '2025-09-07' })
  etd?: string;

  @ApiPropertyOptional({ description: 'Mes', example: 'September' })
  mes?: string;

  // ==================== UBICACIONES ====================
  @ApiPropertyOptional({
    description: 'Fecha retiro contenedor',
    example: '2025-09-01',
  })
  retiroContenedor?: string;

  @ApiPropertyOptional({ description: 'Depósito', example: 'SITRANS SAI' })
  deposito?: string;

  @ApiPropertyOptional({
    description: 'Lugar de origen',
    example: 'SAN ANTONIO',
  })
  lugarOrigen?: string;

  @ApiPropertyOptional({ description: 'Planta', example: 'Planta la Hornilla' })
  planta?: string;

  @ApiPropertyOptional({
    description: 'Puerto de carga',
    example: 'SAN ANTONIO',
  })
  pol?: string;

  @ApiPropertyOptional({ description: 'Terminal', example: 'DPW SAI' })
  terminal?: string;

  @ApiPropertyOptional({
    description: 'Puerto de descarga',
    example: 'PHILADELPHIA, PA',
  })
  pod?: string;

  // ==================== CONTENEDOR ====================
  @ApiPropertyOptional({
    description: 'Número de contenedor',
    example: 'FSCU5863615',
  })
  container?: string;

  @ApiPropertyOptional({ description: 'Número de sello', example: 'LAAE80519' })
  sello?: string;

  @ApiPropertyOptional({ description: 'Cantidad de pallets', example: 20 })
  pallets?: number;

  @ApiPropertyOptional({ description: 'Tipo de contenedor', example: '40 RHC' })
  tipoContenedor?: string;

  @ApiPropertyOptional({ description: 'Transportista', example: 'SERVIFRUIT' })
  transportista?: string;

  @ApiPropertyOptional({ description: 'Costo transporte', example: 450000 })
  costo?: number;

  @ApiPropertyOptional({
    description: 'Tipo de embarque',
    example: 'Contenedor',
  })
  tipoEmbarque?: string;

  @ApiPropertyOptional({ description: 'Ship Convenience', example: 'No' })
  shipConv?: string;

  @ApiPropertyOptional({
    description: 'ID de orden de transporte',
    example: 2158,
  })
  transportOrderId?: number;

  @ApiPropertyOptional({
    description: 'Número de contenedor (duplicado)',
    example: 'FSCU5863615',
  })
  containerNumber?: string;

  // ==================== SERVICIOS ADICIONALES ====================
  @ApiPropertyOptional({ description: 'Servicio Gate Out', example: 15000 })
  servicioGateOut?: number;

  @ApiPropertyOptional({ description: 'Sobrestadía en puerto', example: 0 })
  sobrestadiaPuerto?: number;

  @ApiPropertyOptional({ description: 'Porteos', example: 0 })
  porteos?: number;

  @ApiPropertyOptional({ description: 'Retiro cruzado', example: 0 })
  retiroCruzado?: number;

  @ApiPropertyOptional({ description: 'Sobrestadía en planta', example: 0 })
  sobrestadiaPlanta?: number;

  @ApiPropertyOptional({ description: 'Almacenaje', example: 0 })
  almacenaje?: number;

  @ApiPropertyOptional({ description: 'Falso flete en depósito', example: 0 })
  falsoFleteDeposito?: number;

  @ApiPropertyOptional({ description: 'Sobrestadía en depósito', example: 0 })
  sobrestadiaDeposito?: number;

  @ApiPropertyOptional({ description: 'Falso flete en planta', example: 0 })
  falsoFletePlanta?: number;

  @ApiPropertyOptional({ description: 'Habilitación depósito', example: 0 })
  habilitacionDeposito?: number;

  @ApiPropertyOptional({ description: 'Interplanta', example: 0 })
  interplanta?: number;

  @ApiPropertyOptional({ description: 'Rotulado carga IMO', example: 0 })
  rotuladoCargaImo?: number;

  @ApiPropertyOptional({ description: 'Servicio Gate In', example: 0 })
  servicioGateIn?: number;

  @ApiPropertyOptional({ description: 'Extra Underslung', example: 0 })
  extraUnderslung?: number;

  @ApiPropertyOptional({ description: 'Generador o conexión', example: 0 })
  generadorConexion?: number;

  @ApiPropertyOptional({ description: 'Multa por pesaje', example: 0 })
  multaPesaje?: number;

  @ApiPropertyOptional({ description: 'Manipuleo', example: 0 })
  manipuleo?: number;

  @ApiPropertyOptional({ description: 'Pre-asignación', example: 0 })
  preAsignacion?: number;

  @ApiPropertyOptional({ description: 'Cambio de sellos', example: 0 })
  cambioSellos?: number;

  @ApiPropertyOptional({ description: 'Porteo entrega Zeal', example: 0 })
  porteoEntregaZeal?: number;

  @ApiPropertyOptional({ description: 'Porteo full', example: 0 })
  porteoFull?: number;

  @ApiPropertyOptional({
    description: 'Segundo tramo extra transporte CNTR',
    example: 0,
  })
  segundoTramoExtraCntr?: number;

  @ApiPropertyOptional({
    description: 'Segundo tramo extra transporte PLTS',
    example: 0,
  })
  segundoTramoExtraPlts?: number;

  @ApiPropertyOptional({ description: 'Late Arrival', example: 0 })
  lateArrival?: number;

  @ApiPropertyOptional({ description: 'Factura Late Arrival', example: '' })
  facturaLateArrival?: string;

  @ApiPropertyOptional({ description: 'Extra Late Arrival', example: 0 })
  extraLateArrival?: number;

  @ApiPropertyOptional({
    description: 'Factura Extra Late Arrival',
    example: '',
  })
  facturaExtraLateArrival?: string;

  @ApiPropertyOptional({ description: 'Ingreso en Puerto Tardío', example: 0 })
  ingresoPuertoTardio?: number;

  @ApiPropertyOptional({
    description: 'Factura Ingreso en Puerto Tardío',
    example: '',
  })
  facturaIngresoPuertoTardio?: string;

  @ApiPropertyOptional({ description: 'Pago Tardío de BL Export', example: 0 })
  pagoTardioBlExport?: number;

  @ApiPropertyOptional({
    description: 'Factura Pago Tardío de BL Export',
    example: '',
  })
  facturaPagoTardioBlExport?: string;

  @ApiPropertyOptional({ description: 'Gestión OPB', example: 10000 })
  gestionOpb?: number;

  @ApiPropertyOptional({ description: 'Falso flete ruta a planta', example: 0 })
  falsoFleteRutaPlanta?: number;

  @ApiPropertyOptional({
    description: 'Gestión por anulación gate out',
    example: 0,
  })
  gestionAnulacionGateOut?: number;

  @ApiPropertyOptional({ description: 'Diferencia tarifa flete', example: 0 })
  diferenciaTarifaFlete?: number;

  @ApiPropertyOptional({ description: 'Falso flete full retorno', example: 0 })
  falsoFleteFullRetorno?: number;

  @ApiPropertyOptional({ description: 'Devolución en depósito', example: 0 })
  devolucionDeposito?: number;

  @ApiPropertyOptional({ description: 'Sobrepeso de carga', example: 0 })
  sobrepesoCarga?: number;

  // ==================== SERVICIOS DINÁMICOS ====================
  /**
   * Montos de servicio de esta fila, con una entrada por servicio realmente presente
   * en la liquidación y la clave ya resuelta para la hoja Transportes.
   *
   * Reemplaza a los campos fijos de arriba en esa hoja (los fijos se mantienen porque
   * los consume el Consolidado). Así aparece cualquier servicio, actual o futuro, sin
   * declararlo a mano: el censo del 2026-07-28 encontró 24 nombres sin columna por
   * $10.047.762, más dos columnas declaradas que nunca disparaban porque su `LIKE`
   * era acento-sensible y no coincidía con el nombre real de la BD.
   *
   * El orden de las claves ES el orden de las columnas.
   */
  @ApiPropertyOptional({
    description:
      'Montos de servicio con clave dinámica por servicio presente (hoja Transportes)',
    example: { inspeccionScanner: 437433 },
  })
  servicios?: Record<string, number | string>;

  // ==================== TOTALES ====================
  @ApiPropertyOptional({ description: 'Total venta', example: 450000 })
  totalVenta?: number;

  @ApiPropertyOptional({ description: 'Total traspaso', example: 15000 })
  totalTraspaso?: number;
}

/**
 * DTO para la sección de Transportes V2
 */
export class AgenciaExcelV2TransporteSeccionDto {
  @ApiProperty({ type: [AgenciaExcelV2TransporteRowDto] })
  rows!: AgenciaExcelV2TransporteRowDto[];

  @ApiProperty({ description: 'Total pallets transportados', example: 22 })
  totalPlts!: number;

  @ApiProperty({ description: 'Total costo transporte', example: 750000 })
  totalCosto!: number;

  @ApiProperty({ description: 'Total monto venta', example: 720000.14 })
  totalVenta!: number;

  @ApiProperty({ description: 'Total monto traspaso', example: 0 })
  totalTraspaso!: number;

  @ApiProperty({ description: 'Total general', example: 720000.14 })
  total!: number;

  @ApiPropertyOptional({
    description: 'Total Servicio Gate Out',
    example: 15000,
  })
  totalServicioGateOut?: number;

  @ApiPropertyOptional({
    description: 'Total Sobrestadía en Puerto',
    example: 0,
  })
  totalSobrestadiaPuerto?: number;

  @ApiPropertyOptional({ description: 'Total Porteos', example: 0 })
  totalPorteos?: number;

  @ApiPropertyOptional({ description: 'Total Retiro Cruzado', example: 0 })
  totalRetiroCruzado?: number;

  @ApiPropertyOptional({
    description: 'Total Sobrestadía en Planta',
    example: 0,
  })
  totalSobrestadiaPlanta?: number;

  @ApiPropertyOptional({ description: 'Total Almacenaje', example: 0 })
  totalAlmacenaje?: number;

  @ApiPropertyOptional({
    description: 'Total Falso Flete en Depósito',
    example: 0,
  })
  totalFalsoFleteDeposito?: number;

  @ApiPropertyOptional({
    description: 'Total Sobrestadía en Depósito',
    example: 0,
  })
  totalSobrestadiaDeposito?: number;

  @ApiPropertyOptional({
    description: 'Total Falso Flete en Planta',
    example: 0,
  })
  totalFalsoFletePlanta?: number;

  @ApiPropertyOptional({
    description: 'Total Habilitación Depósito',
    example: 0,
  })
  totalHabilitacionDeposito?: number;

  @ApiPropertyOptional({ description: 'Total Interplanta', example: 0 })
  totalInterplanta?: number;

  @ApiPropertyOptional({ description: 'Total Rotulado Carga IMO', example: 0 })
  totalRotuladoCargaImo?: number;

  @ApiPropertyOptional({ description: 'Total Servicio Gate In', example: 0 })
  totalServicioGateIn?: number;

  @ApiPropertyOptional({ description: 'Total Extra Underslung', example: 0 })
  totalExtraUnderslung?: number;

  @ApiPropertyOptional({
    description: 'Total Generador o Conexión',
    example: 0,
  })
  totalGeneradorConexion?: number;

  @ApiPropertyOptional({ description: 'Total Multa por Pesaje', example: 0 })
  totalMultaPesaje?: number;

  @ApiPropertyOptional({ description: 'Total Manipuleo', example: 0 })
  totalManipuleo?: number;

  @ApiPropertyOptional({ description: 'Total Pre-Asignación', example: 0 })
  totalPreAsignacion?: number;

  @ApiPropertyOptional({ description: 'Total Cambio de Sellos', example: 0 })
  totalCambioSellos?: number;

  @ApiPropertyOptional({ description: 'Total Porteo Entrega Zeal', example: 0 })
  totalPorteoEntregaZeal?: number;

  @ApiPropertyOptional({ description: 'Total Porteo Full', example: 0 })
  totalPorteoFull?: number;

  @ApiPropertyOptional({
    description: 'Total Segundo Tramo Extra Transporte CNTR',
    example: 0,
  })
  totalSegundoTramoExtraCntr?: number;

  @ApiPropertyOptional({
    description: 'Total Segundo Tramo Extra Transporte PLTS',
    example: 0,
  })
  totalSegundoTramoExtraPlts?: number;

  @ApiPropertyOptional({ description: 'Total Late Arrival', example: 0 })
  totalLateArrival?: number;

  @ApiPropertyOptional({ description: 'Total Extra Late Arrival', example: 0 })
  totalExtraLateArrival?: number;

  @ApiPropertyOptional({
    description: 'Total Ingreso en Puerto Tardío',
    example: 0,
  })
  totalIngresoPuertoTardio?: number;

  @ApiPropertyOptional({
    description: 'Total Pago Tardío de BL Export',
    example: 0,
  })
  totalPagoTardioBlExport?: number;

  @ApiPropertyOptional({
    description: 'Total Falso Flete Ruta a Planta',
    example: 0,
  })
  totalFalsoFleteRutaPlanta?: number;

  @ApiPropertyOptional({
    description: 'Total Gestión por Anulación Gate Out',
    example: 0,
  })
  totalGestionAnulacionGateOut?: number;

  @ApiPropertyOptional({
    description: 'Total Diferencia Tarifa Flete',
    example: 0,
  })
  totalDiferenciaTarifaFlete?: number;

  @ApiPropertyOptional({
    description: 'Total Falso Flete Full Retorno',
    example: 0,
  })
  totalFalsoFleteFullRetorno?: number;

  @ApiPropertyOptional({
    description: 'Total Devolución en Depósito',
    example: 0,
  })
  totalDevolucionDeposito?: number;

  @ApiPropertyOptional({ description: 'Total Sobrepeso de Carga', example: 0 })
  totalSobrepesoCarga?: number;

  @ApiPropertyOptional({
    description: 'Servicios presentes (nombres)',
    example: ['servicioGateOut', 'porteos'],
  })
  serviciosPresentes?: string[];
}

/**
 * DTO para el header del reporte V2
 */
export class AgenciaExcelV2HeaderDto {
  @ApiProperty({
    description: 'Número de liquidación formateado',
    example: '000000519',
  })
  numeroLiquidacion!: string;

  @ApiProperty({ description: 'Nombre del cliente', example: 'PANGALILLO SPA' })
  cliente!: string;

  @ApiProperty({
    description: 'Período de la liquidación',
    example: '2025-09-02 al 2025-09-30',
  })
  periodo!: string;

  @ApiPropertyOptional({ description: 'Temporada', example: '2025 - 2025' })
  temporada?: string;

  @ApiProperty({
    description: 'Fecha de generación del reporte',
    example: '2026-01-07',
  })
  fechaGeneracion!: string;

  @ApiProperty({
    description: 'Estado de la liquidación',
    example: 'Finalizado',
  })
  estado!: string;

  @ApiProperty({ description: 'Total contenedores', example: 4 })
  totalCntr!: number;

  @ApiProperty({ description: 'Total pallets', example: 0 })
  totalPlts!: number;

  @ApiProperty({ description: 'Total en USD', example: 392000 })
  totalUsd!: number;

  @ApiProperty({ description: 'Total en CLP', example: 1560400.14 })
  totalClp!: number;
}

/**
 * DTO para una fila de la pestaña Consolidado V2.
 * Cada fila representa un contenedor con TODOS sus costos
 * (agenciamiento + transporte) en una sola línea.
 */
export class AgenciaExcelV2ConsolidadoRowDto {
  // ==================== IDENTIFICACIÓN ====================
  @ApiProperty({ description: 'Número de contenedor', example: 'FSCU5863615' })
  contenedor!: string;

  @ApiProperty({ description: 'Número de liquidación', example: '000000519' })
  nroLiquidacion!: string;

  @ApiProperty({ description: 'Nombre del cliente', example: 'PANGALILLO SPA' })
  cliente!: string;

  @ApiPropertyOptional({
    description: 'Número de factura venta',
    example: 'F-12345',
  })
  nroFacturaVenta?: string;

  @ApiPropertyOptional({
    description: 'Número de nota de cobro',
    example: 'NC-12345',
  })
  nroNotaCobro?: string;

  // ==================== EMBARQUE ====================
  @ApiPropertyOptional({
    description: 'Nombre de la nave',
    example: 'MARTINIQUE',
  })
  nave?: string;

  @ApiPropertyOptional({
    description: 'Puerto de carga',
    example: 'SAN ANTONIO',
  })
  pol?: string;

  @ApiPropertyOptional({
    description: 'Puerto de descarga',
    example: 'PHILADELPHIA',
  })
  pod?: string;

  @ApiPropertyOptional({ description: 'Fecha ETD', example: '2025-09-07' })
  etd?: string;

  @ApiPropertyOptional({
    description: 'Reserva/Booking',
    example: 'SCLF24707600',
  })
  reserva?: string;

  @ApiPropertyOptional({
    description: 'Referencia del cliente',
    example: '256',
  })
  refCliente?: string;

  @ApiPropertyOptional({ description: 'Naviera', example: 'ONE' })
  naviera?: string;

  @ApiPropertyOptional({
    description: 'Tipo de embarque',
    example: 'Contenedor',
  })
  tipoEmbarque?: string;

  @ApiPropertyOptional({ description: 'Pallets en el contenedor', example: 20 })
  plts?: number;

  // ==================== COSTOS AGENCIAMIENTO ====================
  @ApiProperty({ description: 'Monto agenciamiento', example: 98000 })
  agenciamiento!: number;

  @ApiProperty({ description: 'DUS Legalizado', example: 12000 })
  dusLegalizado!: number;

  @ApiProperty({ description: 'Security Fee Contenedor', example: 17196.75 })
  securityFeeContenedor!: number;

  @ApiPropertyOptional({ description: 'UCCO', example: 0 })
  ucco?: number;

  @ApiPropertyOptional({ description: 'UCCO China-Eur', example: 0 })
  uccoChinaEur?: number;

  @ApiPropertyOptional({ description: 'UCCO FGN', example: 0 })
  uccoFgn?: number;

  @ApiPropertyOptional({ description: 'Extra UCCO', example: 0 })
  extraUcco?: number;

  @ApiPropertyOptional({ description: 'Fito', example: 0 })
  fito?: number;

  @ApiPropertyOptional({ description: 'Extra Fito', example: 0 })
  extraFito?: number;

  @ApiPropertyOptional({ description: 'Corrección de BL', example: 0 })
  correccionBl?: number;

  @ApiPropertyOptional({ description: 'Control Sello', example: 0 })
  controlSello?: number;

  // ERR-Nuevo-1 / MEJ-02 (OPB jul-2026): el consolidado ya no expone Gate Out/In ni
  // DUS no legalizado como columnas propias — ruedan a osVenta. Se eliminaron los campos.

  // ==================== COSTOS TRANSPORTE ====================
  @ApiProperty({ description: 'Costo de transporte (flete)', example: 450000 })
  costoTransporte!: number;

  @ApiPropertyOptional({
    description:
      'Otros Servicios Venta (totalVenta - agenciamiento - costoTransporte - gestionOpb)',
    example: 172400,
  })
  osVenta?: number;

  @ApiPropertyOptional({
    description: 'Gestión OPB (ManagementFee, siempre venta — regla 2026-05)',
    example: 25000,
  })
  gestionOpb?: number;

  @ApiPropertyOptional({
    description: 'Servicio Gate Out (transporte)',
    example: 172400,
  })
  servicioGateOut?: number;

  @ApiPropertyOptional({ description: 'Sobrestadía en puerto', example: 0 })
  sobrestadiaPuerto?: number;

  @ApiPropertyOptional({ description: 'Porteos', example: 0 })
  porteos?: number;

  @ApiPropertyOptional({ description: 'Sobrestadía en planta', example: 0 })
  sobrestadiaPlanta?: number;

  @ApiPropertyOptional({ description: 'Falso flete en depósito', example: 0 })
  falsoFleteDeposito?: number;

  @ApiPropertyOptional({ description: 'Falso flete en planta', example: 0 })
  falsoFletePlanta?: number;

  @ApiPropertyOptional({ description: 'Habilitación depósito', example: 0 })
  habilitacionDeposito?: number;

  @ApiPropertyOptional({ description: 'Retiro cruzado', example: 0 })
  retiroCruzado?: number;

  @ApiPropertyOptional({ description: 'Almacenaje', example: 0 })
  almacenaje?: number;

  @ApiPropertyOptional({ description: 'Interplanta', example: 0 })
  interplanta?: number;

  // ==================== TOTALES ====================
  @ApiProperty({ description: 'Total Venta Agenciamiento', example: 98000 })
  totalVentaAgenciamiento!: number;

  @ApiProperty({
    description: 'Total Traspaso Agenciamiento',
    example: 29196.75,
  })
  totalTraspasoAgenciamiento!: number;

  @ApiProperty({ description: 'Total Venta Transporte', example: 622400 })
  totalVentaTransporte!: number;

  @ApiProperty({ description: 'Total Traspaso Transporte', example: 0 })
  totalTraspasoTransporte!: number;

  @ApiProperty({
    description: 'Total Venta (agenciamiento + transporte)',
    example: 720400,
  })
  totalVenta!: number;

  @ApiProperty({
    description: 'Total Traspaso (agenciamiento + transporte)',
    example: 29196.75,
  })
  totalTraspaso!: number;

  @ApiProperty({
    description: 'Total General (venta + traspaso)',
    example: 749596.75,
  })
  totalGeneral!: number;
}

/**
 * DTO para la sección Consolidado V2
 */
export class AgenciaExcelV2ConsolidadoSeccionDto {
  @ApiProperty({ type: [AgenciaExcelV2ConsolidadoRowDto] })
  rows!: AgenciaExcelV2ConsolidadoRowDto[];

  @ApiProperty({ description: 'Total contenedores consolidados', example: 4 })
  totalContenedores!: number;

  @ApiPropertyOptional({ description: 'Total Gestión OPB', example: 25000 })
  totalGestionOpb?: number;

  @ApiProperty({ description: 'Total Venta Agenciamiento', example: 392000 })
  totalVentaAgenciamiento!: number;

  @ApiProperty({ description: 'Total Traspaso Agenciamiento', example: 116787 })
  totalTraspasoAgenciamiento!: number;

  @ApiProperty({ description: 'Total Venta Transporte', example: 922400 })
  totalVentaTransporte!: number;

  @ApiProperty({ description: 'Total Traspaso Transporte', example: 0 })
  totalTraspasoTransporte!: number;

  @ApiProperty({ description: 'Total Venta General', example: 1314400 })
  totalVenta!: number;

  @ApiProperty({ description: 'Total Traspaso General', example: 116787 })
  totalTraspaso!: number;

  @ApiProperty({ description: 'Total General', example: 1431187 })
  totalGeneral!: number;
}

/**
 * DTO principal para el Excel V2
 * 3 pestañas: Agenciamiento, Transportes y Consolidado
 */
export class AgenciaExcelV2DataDto {
  @ApiProperty({ type: AgenciaExcelV2HeaderDto })
  header!: AgenciaExcelV2HeaderDto;

  @ApiProperty({ type: AgenciaExcelV2AgenciamientoSeccionDto })
  agenciamiento!: AgenciaExcelV2AgenciamientoSeccionDto;

  @ApiProperty({ type: AgenciaExcelV2TransporteSeccionDto })
  transportes!: AgenciaExcelV2TransporteSeccionDto;

  @ApiProperty({ type: AgenciaExcelV2ConsolidadoSeccionDto })
  consolidado!: AgenciaExcelV2ConsolidadoSeccionDto;
}
